(function () {
  'use strict';
  var cache = new Map();
  var timer;
  function scan() {
    document.querySelectorAll('.product-card[data-stock-unverified="pending"]').forEach(function (card) {
      card.dataset.stockUnverified = 'loading';
      var link = card.matches('a') ? card : card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var url = new URL(link.href, window.location.origin);
      url.searchParams.set('view', 'stock-verification');
      if (!cache.has(url.href)) cache.set(url.href, fetch(url.href, {credentials:'same-origin'}).then(function (r) {
        if (!r.ok) throw new Error('Stock status unavailable');
        return r.json();
      }).catch(function () { return {held:true, available:false, quantity:0}; }));
      cache.get(url.href).then(function (status) {
        card.dataset.stockUnverified = status.held ? 'true' : 'false';
        card.dataset.inStock = !status.held && status.available && status.quantity > 0 ? 'true' : 'false';
        card.dataset.stockQuantity = status.held ? '0' : String(status.quantity);
        var oldRestock = card.querySelector('.solarboss-restock-date');
        if (oldRestock) oldRestock.remove();
        if (!status.held && !status.available && status.restock && Date.parse(status.restock_expires) > Date.now()) {
          var restock = document.createElement('p');
          restock.className = 'solarboss-restock-date';
          restock.style.cssText = 'font-size:13px;line-height:1.5;margin:8px 0;color:#555';
          restock.dataset.restockExpires = String(Date.parse(status.restock_expires) / 1000);
          restock.textContent = status.restock;
          (card.querySelector('.product-card__button-wrapper') || card).appendChild(restock);
        }
        var note = card.querySelector('.product-card__availability-note');
        if (note) {
          note.textContent = status.held ? 'Call us for stock' : status.available && status.quantity > 0 ? status.quantity + ' available' : 'Out of stock';
          note.classList.toggle('is-out-of-stock', card.dataset.inStock !== 'true');
        }
      });
    });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(scan, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(schedule).observe(document.documentElement, {childList:true, subtree:true});
}());
